import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import {
  IBasket,
  IUnsavedBasket,
  loadBasket,
  saveBasket as saveBasketService,
} from "../services/baskets";
import { useDataMutation } from "@Libs/DataLayer/hooks/useDataMutation";
import { dataLayer } from "@Libs/DataLayer/services/dataLayer";

export const useBasket = (id: string) => {
  const {
    data: basket,
    isLoading,
    isError,
    error: apiError,
  } = useDataQuery<IBasket>(
    ["basket", id],
    async () => {
      try {
        const basket = await loadBasket(id);
        return basket;
      } catch (error) {
        return {
          id,
          items: [],
        };
      }
    },
    {
      enabled: !!id,
    }
  );

  const { mutate: saveBasket, isLoading: isSavingBasket } = useDataMutation(
    ["baskets", id],
    async (basket: IUnsavedBasket) => {
      const data = await saveBasketService(basket);
      dataLayer.setQueryData(["basket", id], data);
      return data;
    }
  );

  const hasBasketSubscription = basket?.items.find(
    (basketItem) => basketItem.itemType === "product"
  );

  return {
    basket,
    isLoading,
    isError,
    saveBasket,
    isSavingBasket,
    hasBasketSubscription,
    apiError,
  };
};
